import React from 'react';
import { ForwardStep } from '@saleshandy/icons';

const TaskSkipped = () => (
  <ForwardStep className='orange-txt-16' />
);

export default TaskSkipped;
